import styled from "styled-components";
import moment from "moment-timezone";
import { RATypography, RAMap } from "@/components/customs";
import { Row, Col } from "antd";
import { SvgCalendar, SvgCharter, SvgProfile } from "@/assets/icons";
import { AirportLegInfo } from "../AirportLegInfo";
import { selectFormatDateTimeFull } from "@/stores/slices/authSlice";
import { useSelector } from "react-redux";

export function FormRequestSummaryLegItem({
	formValues = {},
	categories = [],
	legs = [],
	type,
	aircraft = {},
	formatTimezone = true,
}) {
	const { from_airport, to_airport, departure_datetime, departure_window_datetime, passengers } = formValues;
	const formatDTFull = useSelector(selectFormatDateTimeFull);

	const getTrips = () => {
		let trips = [];
		legs.forEach((leg) => {
			const { from_airport, to_airport } = leg;
			if (from_airport && to_airport) {
				trips.push(leg);
			}
		});
		return trips;
	};

	const getValueWithTimezone = () => {
		if (formatTimezone) {
			return departure_datetime
				? moment(departure_datetime).tz(from_airport?.location?.timezone).format(formatDTFull)
				: "TBD";
		}

		return departure_datetime ? moment(departure_datetime).format(formatDTFull) : "TBD";
	};

	const getDepartureWindowWithTimezone = () => {
		if (!departure_window_datetime) return null;
		if (formatTimezone) {
			return departure_window_datetime
				? moment(departure_window_datetime).tz(from_airport?.location?.timezone).format(formatDTFull)
				: "TBD";
		}

		return departure_window_datetime ? moment(departure_window_datetime).format(formatDTFull) : "TBD";
	};

	return (
		<WrapperFlightInfo>
			<WrapperLegInfo className="ra-box-d">
				<AirportLegInfo from_airport={from_airport} to_airport={to_airport} />
			</WrapperLegInfo>
			<RAMap trip={getTrips()} />
			<Row gutter={[12, 12]} style={{ marginTop: 20 }}>
				<Col xs={24} md={8}>
					<CardItem
						icon={<SvgCalendar color="#595959" />}
						label={departure_window_datetime ? "Departure window" : "Departure time"}
						value={getValueWithTimezone()}
						departureWindow={getDepartureWindowWithTimezone()}
					/>
				</Col>
				<Col xs={24} md={8}>
					<CardItem
						icon={<SvgProfile color="#595959" />}
						label="Passengers"
						value={`${passengers ?? 1} PAX`}
					/>
				</Col>
				<Col xs={24} md={8}>
					{type === "EMPTY_LEG" ? (
						<CardItem
							icon={<SvgCharter color="#595959" />}
							label="Aircraft"
							value={`${aircraft?.name} - ${aircraft?.tail_number}`}
						/>
					) : (
						<CardItem
							icon={<SvgCharter color="#595959" />}
							label="Aircraft Category"
							value={categories?.length > 0 ? categories.map((v) => v.name).join(", ") : "_"}
						/>
					)}
				</Col>
			</Row>
		</WrapperFlightInfo>
	);
}

const CardItem = ({ icon, label = "", value = "", departureWindow }) => {
	const _renderValue = () => {
		if (departureWindow) {
			return (
				<>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 12,
						}}
					>
						<RATypography style={{ width: 40 }} variant="body3" color="#595959">
							From
						</RATypography>
						<RATypography variant="sub-heading4" color="#222222">
							{value}
						</RATypography>
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 12,
						}}
					>
						<RATypography style={{ width: 40 }} variant="body3" color="#595959">
							To
						</RATypography>
						<RATypography variant="sub-heading4" color="#222222">
							{departureWindow}
						</RATypography>
					</div>
				</>
			);
		}
		return (
			<RATypography variant="sub-heading4" color="#222222" style={{ textTransform: "uppercase" }}>
				{value}
			</RATypography>
		);
	};
	return (
		<>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 8,
					marginBottom: 12,
				}}
			>
				<div style={{ display: "flex" }}>{icon}</div>
				<RATypography variant="body3" color="#595959">
					{label}
				</RATypography>
			</div>
			{_renderValue()}
		</>
	);
};

const WrapperFlightInfo = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
`;

const WrapperLegInfo = styled.div`
	width: 100%;
	padding: 16px clamp(4px, 2vw, 20px);
	gap: 16px;
	min-height: 72px;
	border: 1px dashed #e9e8e8;
	border-radius: 10px;
`;
